import { getRatesEnterpriseCityByEnterpriseRequest } from "../../data/ratesEnterpriseCityApi";

function getPayloadData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getTarifaEnterpriseCityByEnterpriseUseCase(enterpriseId) {
  if (!enterpriseId) {
    throw new Error("El id de la empresa es obligatorio.");
  }

  try {
    return getPayloadData(
      await getRatesEnterpriseCityByEnterpriseRequest(enterpriseId),
    );
  } catch (error) {
    if (
      error?.response?.data?.message === "ERROR_EMPTY_ENTERPRISE_CITY_RATE"
    ) {
      return null;
    }

    throw error;
  }
}
